// extracted by mini-css-extract-plugin
module.exports = {"OutlineLabel":"OutlineLabel_OutlineLabel__VBiY0"};